"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGuidelineDescription = exports.StyledGuidelineTitle = exports.StyledGuideline = exports.StyledGuidelinesContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledGuidelinesContainer = styled_components_1.default.div ``;
exports.StyledGuideline = styled_components_1.default.div `
  padding: 1rem;

  &:not(:last-child) {
    border-bottom: 1px solid ${ui_components_1.baseColors.gray200};
  }
`;
exports.StyledGuidelineTitle = styled_components_1.default.h6 `
  margin: 0;
  font-weight: 600;
  line-height: 160%;
  margin-bottom: 0.25rem;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
  font-size: 1rem;
`;
exports.StyledGuidelineDescription = styled_components_1.default.p `
  margin: 0;
  font-size: 0.875rem;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
  line-height: 140%;
`;
